import React from 'react';
import CommunityViewNew from './CommunityViewNew';

/**
 * Variante B: tarjeta de horarios **arriba de Miembros** (columna derecha
 * de la card grid principal, a la derecha de Productos).
 *
 * URL: /communities2/:id
 */
export default function CommunityView2() {
  return <CommunityViewNew scheduleCardPlacement="above-members" />;
}
